var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkChainIcon = function SvgLinkChainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4405_10071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7237 9.1742C9.69582 8.1463 7.70644 8.06834 6.54077 9.23401L5.83378 9.941C4.66234 11.1124 4.63553 12.9855 5.77397 14.1239C6.75485 15.1048 8.28102 15.2203 9.4339 14.484C9.62283 14.3633 9.79806 14.2224 9.95651 14.0637",
    stroke: "#6371DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07378 10.8241C10.1013 11.8516 12.0906 11.9296 13.2563 10.7639L13.9633 10.0569C15.1347 8.88549 15.162 7.01284 14.0235 5.8744C13.0422 4.89311 11.5157 4.7772 10.3632 5.51389C10.1743 5.63464 9.99903 5.77558 9.84058 5.93421",
    stroke: "#6371DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4405_10071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 10) rotate(-45)"
  })))));
};
export default SvgLinkChainIcon;